import { createTypes, async } from 'redux-action-creator'

export default createTypes(
  [
    ...async('FETCH'),
    'SELECT_TRANSACTION',
    ...async('CANCEL_APPOINTMENT'),
    'SET_CANCEL_DIALOG_OPEN',
    'SET_VIEW_DIALOG_OPEN',
    ...async('FETCH_TRANSACTION')
  ],
  'ACTIVITY/APPOINTMENTS/',
)



// WEBPACK FOOTER //
// ./src/sections/activity/types/appointments.js